import { Merchant, MerchantData } from '@nemuru-eng/js-api-client';
import React from 'react';

import { MerchantLegalAddressEditDialog } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantLegalAddress/components/MerchantLegalAddressEditDialog';
import { MerchantLegalAddressForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantLegalAddress/components/MerchantLegalAddressForm';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';

export const MerchantLegalAddress: React.FC<{
  merchant: Merchant;
  merchantData?: MerchantData;
  editModeAllowed?: boolean;
}> = ({ merchant, merchantData, editModeAllowed = false }) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const actions: ActionsOption[] | undefined = editModeAllowed
    ? [
        {
          display: <Text tId={!merchantData ? 'ADD_LEGAL_ADDRESS' : 'EDIT_LEGAL_ADDRESS'} />,
          onClick: toggleDialog,
          iconName: 'edit',
        },
      ]
    : undefined;

  return (
    <SubSectionWrapper title={'LEGAL_ADDRESS'} specificActionsOptionsArray={actions}>
      {!merchantData ? <PendingDataWarning /> : <MerchantLegalAddressForm merchantData={merchantData} />}
      <MerchantLegalAddressEditDialog
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
        merchantId={merchant.id}
        merchantData={merchantData}
      />
    </SubSectionWrapper>
  );
};
